import React, { useState, useEffect } from "react";
import { Button, Col, Form, Row, Spinner } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { updatePartnerDetails } from "../../../slices/partner/action";
import { useDispatch } from "react-redux";
import { alertError, alertSuccess } from "../../../helpers/errorHandling";

const StatementConfigForm = ({ partnerDetails, handleUpdate }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);

  const toggleDay = (day) => {
    setSelectedDays((prev) => {
      const newDays = prev?.includes(day)
        ? prev?.filter((d) => d !== day)
        : [...prev, day];
      validation?.setFieldValue("daysOfMonth", newDays);
      validation?.setFieldTouched("daysOfMonth", true);
      return newDays;
    });
  };

  const validation = useFormik({
    initialValues: {
      daysOfMonth: [],
    },
    validationSchema: Yup.object({
      daysOfMonth: Yup.array().min(1, "Please select at least one day"),
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const res = await updatePartnerDetails(
          { statementDays: selectedDays },
          dispatch
        );

        if (res?._id) {
          alertSuccess("Updated Successfully");
        } else {
          alertError({ message: "Failed, Please try again" });
        }

        handleUpdate();
        setTimeout(() => {
          setIsLoading(false);
        }, 1500);
      } catch (e) {
        console.log(e);
      }
    },
  });

  useEffect(() => {
    if (partnerDetails?.statementDays) {
      setSelectedDays(partnerDetails?.statementDays);
    }
  }, [partnerDetails]);

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        validation.handleSubmit();
      }}
    >
      <Row>
        <Col md={12} className="mb-3">
          <label className="form-label">
            Please choose the days of the month on which you want to generate
            the statement.
          </label>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {Array.from({ length: 28 }, (_, i) => i + 1).map((day) => (
              <div
                key={day}
                className={`p-1 border rounded text-center ${
                  selectedDays.includes(day)
                    ? "bg-primary text-white"
                    : "bg-light"
                }`}
                style={{ width: "40px", cursor: "pointer" }}
                onClick={() => toggleDay(day)}
              >
                {day}
              </div>
            ))}
          </div>
          {validation.touched.daysOfMonth &&
            validation.errors.daysOfMonth &&
            selectedDays?.length === 0 && (
              <div className="text-danger mt-2">
                {validation.errors.daysOfMonth}
              </div>
            )}
        </Col>
      </Row>

      <Button color="primary" type="submit" disabled={isLoading} size="sm">
        {isLoading ? <Spinner size="sm" /> : "Save"}
      </Button>
    </Form>
  );
};

export default StatementConfigForm;

StatementConfigForm.propTypes = {
  partnerDetails: PropTypes.object,
  handleUpdate: PropTypes.func.isRequired,
};
